/** @enum {string} */
export const DEFAULT_CAMPAIGN_TRIGGER_TYPE = {
  AFTER_TIME: 'after_time',
  AFTER_SCROLL: 'after_scroll'
};

/** @enum {string} */
export const DEFAULT_CAMPAIGN_PAGE_DISPLAY_ON = {
  ALL: 'all',
  SPECIFIC: 'specific',
  PRODUCT: 'product',
  SPECIFIC_PRODUCT: 'specific_product'
};

/** @enum {number} */
export const DEFAULT_CAMPAIGN_MINIMUM_CART_VALUE = 0;

export const DEFAULT_CAMPAIGN_AUDIENCE = {
  ALL: 'all',
  ONLY_VISITORS: 'only_visitors',
  ONLY_CUSTOMERS: 'only_customers'
};

export const DEFAULT_CAMPAIGN_DISPLAY_TIME = {
  ALL_TIME: 'all_time',
  BUSINESS_HOURS_ONLY: 'during_business'
};

export const DEFAULT_CAMPAIGN_DEVICE = {
  ALL: 'all',
  DESKTOP_ONLY: 'only_desktop',
  MOBILE_ONLY: 'only_mobile'
};

export const DEFAULT_CAMPAIGN_DURATION = {
  ALWAYS: 'always',
  CUSTOM: 'custom'
};

export const DEFAULT_MESSAGE_TYPE = {
  TEXT: 'text',
  PRODUCT_RECOMMENDATION: 'product_recommendation',
  DISCOUNT: 'discount'
};

export const DEFAULT_PRODUCT_RECOMMENDATION_TYPE = {
  CUSTOM: 'custom',
  NEW_ARRIVALS: 'new_arrivals',
  BEST_SELLERS: 'best_sellers'
};

export const DEFAULT_MESSAGE_TABS = [
  {
    id: DEFAULT_MESSAGE_TYPE.TEXT,
    content: 'Text'
  },
  {
    id: DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION,
    content: 'Product Recommendation'
  },
  {
    id: DEFAULT_MESSAGE_TYPE.DISCOUNT,
    content: 'Discount'
  }
];

export const DEFAULT_CAMPAIGN_SETTINGS = {
  welcome_message: {
    name: 'Welcome message',
    trigger: {
      type: DEFAULT_CAMPAIGN_TRIGGER_TYPE.AFTER_TIME,
      value: 5
    },
    condition: {
      audience: DEFAULT_CAMPAIGN_AUDIENCE.ALL,
      displayTime: DEFAULT_CAMPAIGN_DISPLAY_TIME.ALL_TIME,
      device: DEFAULT_CAMPAIGN_DEVICE.ALL,
      duration: {
        type: DEFAULT_CAMPAIGN_DURATION.ALWAYS,
        value: 10
      }
    },
    message: {
      type: DEFAULT_MESSAGE_TYPE.TEXT,
      content: '<p>Hi {{customer_name}} 👋</p><p>How can we help you?</p>'
    }
  },
  subscribe_newsletter: {
    name: 'Subscribe Newsletter',
    trigger: {
      type: DEFAULT_CAMPAIGN_TRIGGER_TYPE.AFTER_TIME,
      value: 5,
      displayOn: {
        type: DEFAULT_CAMPAIGN_PAGE_DISPLAY_ON.ALL,
        value: []
      }
    },
    condition: {
      audience: DEFAULT_CAMPAIGN_AUDIENCE.ALL,
      displayTime: DEFAULT_CAMPAIGN_DISPLAY_TIME.ALL_TIME,
      device: DEFAULT_CAMPAIGN_DEVICE.ALL,
      duration: {
        type: DEFAULT_CAMPAIGN_DURATION.ALWAYS,
        value: 10
      }
    },
    message: {
      type: DEFAULT_MESSAGE_TYPE.DISCOUNT,
      content: `<p>Don't miss out 👋</p><p>Discover the special offer we're tailored for you!</p>`,
      discount: null,
      marketingOptIn: false,
      formFields: ['email'],
      successMessage:
        'Thank you for subscribing! Check your inbox and stay tuned for the latest news and exclusive offers.',
      emailMessage: 'Check your email to confirm your subscription.'
    }
  },
  product_recommendation: {
    name: 'Product Recommendation',
    trigger: {
      type: DEFAULT_CAMPAIGN_TRIGGER_TYPE.AFTER_TIME,
      value: 5,
      displayOn: {
        type: DEFAULT_CAMPAIGN_PAGE_DISPLAY_ON.PRODUCT,
        value: []
      }
    },
    condition: {
      audience: DEFAULT_CAMPAIGN_AUDIENCE.ALL,
      displayTime: DEFAULT_CAMPAIGN_DISPLAY_TIME.ALL_TIME,
      device: DEFAULT_CAMPAIGN_DEVICE.ALL,
      duration: {
        type: DEFAULT_CAMPAIGN_DURATION.ALWAYS,
        value: 10
      }
    },
    message: {
      productContent: '<p>You might like this product!</p>',
      type: DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION,
      productsList: [],
      productType: DEFAULT_PRODUCT_RECOMMENDATION_TYPE.BEST_SELLERS
    }
  },
  cart_booster: {
    name: 'Cart Booster',
    trigger: {
      type: DEFAULT_CAMPAIGN_TRIGGER_TYPE.AFTER_TIME,
      value: 5,
      minimumCartValue: DEFAULT_CAMPAIGN_MINIMUM_CART_VALUE,
      displayOn: {
        type: DEFAULT_CAMPAIGN_PAGE_DISPLAY_ON.ALL,
        value: []
      }
    },
    condition: {
      audience: DEFAULT_CAMPAIGN_AUDIENCE.ALL,
      displayTime: DEFAULT_CAMPAIGN_DISPLAY_TIME.ALL_TIME,
      device: DEFAULT_CAMPAIGN_DEVICE.ALL,
      duration: {
        type: DEFAULT_CAMPAIGN_DURATION.ALWAYS,
        value: 10
      }
    },
    message: {
      type: DEFAULT_MESSAGE_TYPE.TEXT,
      content:
        '<p>Good choice 🛍️ Thanks for your interest! Want to learn more or place an order now?</p>',
      productContent: '<p>You might like this product!</p>',
      discountContent:
        "<p>Hey there! 🎉</p><p>We've got an exclusive Black Friday coupon just for you. Click to get your discount! Limited time only!</p>",
      productsList: [],
      productType: DEFAULT_PRODUCT_RECOMMENDATION_TYPE.BEST_SELLERS,
      discount: null,
      usageInstruction:
        'This coupon is valid for summer clothing, with all items eligible for a 20% discount'
    }
  }
};
